export default __webpack_public_path__ + "static/media/Sielanka-wesele.443a47a3.JPG";